import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import ManageAlert from '../manageAlert/ManageAlert.vue'

export default {
  async created() {
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getUsers()
    this.getInstitutions()
    this.getUnidades()
    this.updateTable()
  },

  data: () => ({
    totalItensOnPage: 0,
    visible: false,
    dialog: false,
    editDialog: false,
    deleteDialog: false,
    deleteManyDialog: false,
    dialogKey: false,
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    userLoading: false,
    departmentLoading: false,
    error: false,
    buttonDeleteVisible: false,
    menuInitialEventDate: false,
    menuFinalEventDate: false,
    minDate: null,
    expanded: [],
    alertsSelected: [],
    alerts: [],
    alertsModule: [
      'OS',
      'Equipamento',
      'Contrato',
      'Tarefa',
      'Padrão calibração',
      'Arquivo externo controle',
      'Item',
    ],
    alertsStatus: ['Aberto', 'Fechado'],
    currentAlert: {},
    page: 1,
    totalPages: 1,
    pageSize: 10,
    sizes: [10, 30, 90, 180],
    totalItems: 0,
    institutionId: null,
    institutions: [],
    unidadeId: null,
    unidades: [],
    filter: {
      page: 1,
      pageSize: 10,
      institutionId: null,
      unidadeId: null,
      description: null,
      alertModule: -1,
      status: 0,
      initialEventDate: null,
      finalEventDate: null,
      userId: null,
      standardInitialDate: null,
      standardFinalDate: null,
    },
    alertDescription: null,
    alertModule: -1,
    alertStatus: 0,
    alertEventDate: null,
    alertDate: null,
    alertEventInitialDate: null,
    alertEventFinalDate: null,
    initialEventDate: null,
    finalEventDate: null,
    headers: [
      {
        text: 'Descrição',
        align: 'center',

        value: 'description',
      },
      {
        text: 'Módulo',
        align: 'center',

        value: 'module',
      },
      {
        text: 'Data evento',
        align: 'center',

        value: 'eventDate',
      },
      {
        text: 'Data alerta',

        align: 'center',
        value: 'alertDate',
      },
      {
        text: 'Status',

        align: 'center',
        value: 'status',
      },
      {
        text: 'Ações',

        value: 'actions',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Descrição',
        align: 'center',

        value: 'description',
      },
      {
        text: 'Dt.Evento',
        align: 'center',

        value: 'eventDate',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  components: {
    ManageAlert,
  },

  methods: {
    addAlert() {
      this.dialogKey = !this.dialogKey
      this.dialog = true
    },

    editAlert(alert) {
      this.currentAlert = alert
      this.dialogKey = !this.dialogKey
      this.editDialog = true
    },

    deleteAlert(alert) {
      this.currentAlert = alert
      this.dialogKey = !this.dialogKey
      this.deleteDialog = true
    },

    deleteManyAlerts() {
      this.dialogKey = !this.dialogKey
      this.deleteManyDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.editDialog = false

      this.updateTable()
    },

    filterTable() {
      this.page = 1
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.description = this.alertDescription
      this.filter.unidadeId = this.unidadeId
      this.filter.alertModule = this.alertsModule.indexOf(this.alertModule)
      this.filter.status =
        this.alertsStatus.indexOf(this.alertStatus) === -1
          ? 0
          : this.alertsStatus.indexOf(this.alertStatus)
      this.filter.initialEventDate = this.parseDate(this.initialEventDate)
      this.filter.finalEventDate = this.parseDate(this.finalEventDate)

      this.updateTable()
    },

    async updateTable() {
      this.loading = true
      this.filter.standardInitialDate = Utils.startOfWeek(new Date())
      this.filter.standardFinalDate = Utils.endOfWeek(this.standardInitialDate)
      this.filter.userId = JSON.parse(localStorage.getItem('user')).id
      this.filter.institutionId = this.institutionId

      await this.apiService.post('alert/list', this.filter).then((response) => {
        this.totalPages = response.content.pager.totalPages
        this.alerts = response.content.alerts
        this.totalItems = response.content.pager.totalItems
        this.totalItensOnPage = response.content.alerts.length
        this.loading = false
      })
    },

    async remove() {
      this.loading = true

      await this.apiService
        .delete('alert/delete', this.currentAlert)
        .then(() => {
          this.loading = false
          this.deleteDialog = false
          this.updateTable()
        })
        .catch(() => {
          this.loading = false
          this.deleteDialog = false
        })
    },

    async removeMany() {
      this.loading = true

      await this.apiService
        .delete('alert/deleteMany', this.alertsSelected)
        .then(() => {
          this.updateTable()
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
      this.loading = false
      this.deleteManyDialog = false
      this.buttonDeleteVisible = false
      this.alertsSelected = []
    },

    async getUsers() {
      this.userLoading = true

      await this.apiService
        .get(`user/list/${this.institutionId}`)
        .then((resposne) => {
          this.users = resposne.content
          this.userLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true
      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
        })
        .catch((err) => {})

      this.institutionLoading = false
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    reset() {
      this.filter = {
        page: 1,
        pageSize: 10,
        unidadeId: null,
        description: null,
        alertModule: -1,
        status: 0,
        initialEventDate: null,
        finalEventDate: null,
        standardInitialDate: null,
        standardFinalDate: null,
      }
      this.alertDescription = null
      this.alertModule = -1
      this.alertStatus = 0
      this.alertEventDate = null
      this.alertDate = null
      this.initialEventDate = null
      this.finalEventDate = null
      this.unidadeId = null
      this.alertEventFinalDate = null
      this.alertEventInitialDate = null

      this.updateTable()
    },

    getStatus(status, datetime) {
      switch (status) {
        case 0:
          return this.compareDatetime(datetime)
            ? 'Alerta agendado'
            : 'Alerta atrasado'
        default:
          return 'Realizado'
      }
    },

    getStatusClass(status, datetime) {
      switch (status) {
        case 0:
          return this.compareDatetime(datetime) ? 'scheduled' : 'late'
        default:
          return 'realized'
      }
    },

    compareDatetime(datetime) {
      return Utils.compareDateTime(datetime)
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.initialEventDate = this.formatInputDate(this.alertEventInitialDate)
      this.$refs.menuInitialEventDate.save(date)
      this.minDate = new Date(this.alertEventInitialDate)
        .toISOString()
        .substr(0, 10)
      this.finalEventDate = this.formatInputDate(this.alertEventFinalDate)
      this.$refs.menuFinalEventDate.save(date)
    },
  },

  watch: {
    pageSize() {
      this.filter.pageSize = this.pageSize
      this.filter.page = 1
      this.updateTable()
    },

    page() {
      this.filter.page = this.page
      this.updateTable()
    },

    alertsSelected() {
      this.buttonDeleteVisible = this.alertsSelected.length > 0
    },
  },
}
